import { useState, useContext, useEffect, useCallback } from "react";
import { loaderContext } from "../contexts/LoaderProvider";
import { dataContext } from "../contexts/DataProvider";
import { errorContext } from "../contexts/ErrorProvider";
import validate from "../validation/validator";
import { employeeProfileSecuritySchema } from "../validation/schema";
import { editEmployeePassword } from "../services/settingsService";
import PasswordField from "../utils/PasswordField";

const Security = () => {
  const [data, setData] = useContext(dataContext);
  const [errors, setErrors] = useContext(errorContext);
  const [alertMessage, setAlertMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const { setIsLoading } = useContext(loaderContext);

  const update = useCallback(async () => {
    const validation = validate(
      data,
      setErrors,
      employeeProfileSecuritySchema()
    );
    if (validation === true) {
      setIsLoading(true);
      const response = await editEmployeePassword(data);
      if (response.data.code === 1) {
        setSuccessMessage(response.data.message);
        setData({});
        setErrors({});
      } else {
        setAlertMessage(response.data.message);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line
  }, [data, errors]);
  useEffect(() => {
    setAlertMessage(null);
    setTimeout(() => {
      setSuccessMessage(null);
    }, 1000);
    // eslint-disable-next-line
  }, [data]);

  return (
    <div className="col-md-12">
      <div className="card custom-card">
        <div className="card-header justify-content-between">
          <div className="card-title">
            <div className="d-flex justify-content-between align-items-center px-3 gap-2">
              <span className="d-block fw-medium fs-15">Security Details</span>
            </div>
          </div>
        </div>
        <div className="card-body">
          {alertMessage && (
            <div className="alert alert-solid-danger alert-dismissible fade show">
              {alertMessage ?? ""}
              <button
                onClick={() => setAlertMessage(null)}
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
          )}
          {successMessage && (
            <div className="alert alert-solid-success alert-dismissible fade show">
              {successMessage ?? ""}
              <button
                onClick={() => setSuccessMessage(null)}
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
          )}
          <div className="row">
            <div className="col-xl-6 mb-2">
              <label className="form-label text-default d-block">
                Old Password
              </label>
              <PasswordField
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                field="oldPassword"
                value={data?.oldPassword ?? ""}
              />
            </div>
            <div className="col-xl-6 mb-2">
              <label className="form-label text-default d-block">
                New Password
              </label>
              <PasswordField
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                field="password"
                value={data?.password ?? ""}
              />
            </div>
            <div className="col-xl-6 mb-2">
              <label className="form-label text-default d-block">
                Confirm Password
              </label>
              <PasswordField
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                field="confirmPassword"
                value={data?.confirmPassword ?? ""}
              />
            </div>
          </div>
        </div>
        <div className="card-footer text-end">
          <button onClick={update} className="btn btn-primary btn-md me-2">
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default Security;
